export const getDeepCopy = (object) => JSON.parse(JSON.stringify(object));
